import React from 'react'

import { Dropdown } from 'Components/input'
import useGetData from 'Hooks/useGetData.js'

const CountryDropdown = (props) => {
  const [isLoading, countryList] = useGetData('/rapi/organisation/countries', [])

  return <Dropdown options={countryList} disabled={isLoading} {...props} />
}

export default CountryDropdown
